import { adminMeSchema, ApiError, queryKeys, type AdminMe } from '@fidalia/api';
import { Spinner } from '@fidalia/ui';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { AdminLayout } from '@/features/admin/admin-layout';

/**
 * Layout du back-office. La session est vérifiée auprès du backend : un jeton
 * de membre de cabinet (audience `user`) est rejeté ici par l'API, il ne
 * suffit donc pas d'en fabriquer un pour entrer.
 */
export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context }) => {
    if (context.tokens.get() === null) throw redirect({ to: '/login' });

    try {
      const me = await context.queryClient.ensureQueryData({
        queryKey: queryKeys.adminAuth.me(),
        queryFn: () => context.api.get<AdminMe>('/admin/auth/me', { schema: adminMeSchema }),
        staleTime: 5 * 60_000,
      });

      return { me };
    } catch (error) {
      if (error instanceof ApiError && error.status === 401) {
        throw redirect({ to: '/login' });
      }
      throw error;
    }
  },
  pendingComponent: () => (
    <div className="fixed inset-0 grid place-items-center bg-surface">
      <Spinner />
    </div>
  ),
  component: () => (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  ),
});
